import {
  SlRadioGroup,
  radio_group_styles_default
} from "./chunk.W2PN5H2J.js";
import {
  getTag,
  hasTag
} from "./chunk.UFU6LZT7.js";
import {
  o
} from "./chunk.OBPYZVEK.js";
import {
  n,
  t
} from "./chunk.D5EJUUKV.js";
import {
  component_mobile_styles_default
} from "./chunk.3DO35SD7.js";
import {
  $,
  r
} from "./chunk.4JTBA2KG.js";
import {
  __decorateClass
} from "./chunk.K2NRSETB.js";

// src/components/radio-group/radio-group.ts
var supportedRadios = ["fadv-radio", "fadv-radio-card", "fadv-radio-button"];
var FadvRadioGroup = class extends SlRadioGroup {
  getAllRadios() {
    return [...this.querySelectorAll(supportedRadios.join(","))].filter((el) => supportedRadios.includes(getTag(el)));
  }
  handleRadioClick(event) {
    const target = event.target;
    const checkedRadio = target.closest(supportedRadios.map((selector) => `${selector}:not([disabled])`).join(","));
    if (checkedRadio) {
      const radios = this.getAllRadios();
      radios.forEach((radio) => {
        radio.checked = radio === checkedRadio;
        radio.input.tabIndex = radio === checkedRadio ? 0 : -1;
      });
    }
  }
  handleSlotChange() {
    const radios = this.getAllRadios();
    const checkedRadio = radios.find((radio) => radio.checked);
    this.hasButtonGroup = !!radios.find((radio) => hasTag(radio, "fadv-radio-button"));
    this.needButtonGroup = !this.querySelectorAll("fadv-button-group, fadv-button-grid").length;
    radios.forEach((radio) => {
      radio.setAttribute("role", "radio");
      if (radio.input) {
        radio.input.tabIndex = -1;
      }
    });
    if (checkedRadio) {
      checkedRadio.input.tabIndex = 0;
    } else if (radios.length > 0 && radios[0].input) {
      radios[0].input.tabIndex = 0;
    }
  }
  render() {
    const defaultSlot = $`<slot @click=${this.handleRadioClick} @keydown=${this.handleKeyDown} @slotchange=${this.handleSlotChange}></slot>`;
    return $`<fieldset part="base" class=${o({
      "radio-group": true,
      "radio-group--has-fieldset": this.fieldset
    })} ><legend part="label" class="radio-group__label"><slot name="label">${this.label}</slot></legend>${this.hasButtonGroup && this.needButtonGroup ? $`<fadv-button-group part="button-group">${defaultSlot}</fadv-button-group>` : defaultSlot}</fieldset>`;
  }
};
FadvRadioGroup.styles = r` ${radio_group_styles_default} ${component_mobile_styles_default} ::slotted(fadv-radio:not(:last-of-type)) { display: block; margin-bottom: var(--sl-spacing-2x-small); } `;
__decorateClass([
  t()
], FadvRadioGroup.prototype, "needButtonGroup", 2);
FadvRadioGroup = __decorateClass([
  n("fadv-radio-group")
], FadvRadioGroup);

export {
  FadvRadioGroup
};
